const homepageVideoEmbedUrl = 'https://www.youtube.com/embed/DcINCdaWtCE';

export default function HomepageVideoSection() {
  return (
    <section className="py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="w-full max-w-4xl mx-auto overflow-hidden rounded-2xl border border-border bg-card shadow-xl">
          <iframe
            src={homepageVideoEmbedUrl}
            title="Homepage featured video"
            className="w-full"
            style={{ aspectRatio: '16 / 9' }}
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
